import {
  Action,
  ActionType,
  PageType,
  State,
} from "components/StatementPreference/reducer/types";

export const statementPreferenceReducer = (state: State, action: Action) => {
  switch (state.page) {
    case PageType.LANDING: {
      switch (action.type) {
        case ActionType.ALL_DATA_LOADED: {
          return {
            ...state,
            accountInfo: action.accountInfo,
            statementPreferences: action.statementPreferences,
            personalDetails: action.personalDetails,
            submitUrl: action.submitUrl,
            createSessionUrl: action.createSessionUrl,
            personalDetailsUnmaskedUrl: action.personalDetailsUnmaskedUrl,
            page: PageType.STATEMENT_PREFERENCE,
          };
        }
        case ActionType.NO_EMAIL: {
          return {
            ...state,
            accountInfo: action.accountInfo,
            page: PageType.NO_EMAIL,
          };
        }
        case ActionType.ERROR: {
          return {
            ...state,
            page: PageType.ERROR,
            accountInfo: action.accountInfo,
          };
        }
        case ActionType.JOINT_ACCOUNT: {
          return {
            ...state,
            page: PageType.JOINT_ACCOUNT,
            accountInfo: action.accountInfo,
          };
        }
        default: {
          return state;
        }
      }
    }
    case PageType.STATEMENT_PREFERENCE: {
      switch (action.type) {
        case ActionType.OTP: {
          return {
            ...state,
            page: PageType.OTP,
          };
        }
        case ActionType.SUCCESS: {
          return {
            ...state,
            statementPreferences: action.statementPreferences,
            page: PageType.SUCCESS,
          };
        }
        case ActionType.ERROR:
        case ActionType.SUBMIT_FAILED: {
          return { ...state, page: PageType.ERROR };
        }
        default: {
          return state;
        }
      }
    }
    case PageType.OTP: {
      switch (action.type) {
        case ActionType.OTP_SUCCESS: {
          return {
            ...state,
            page: PageType.STATEMENT_PREFERENCE,
            personalDetails: action.personalDetails,
          };
        }
        case ActionType.OTP_FAILED: {
          return { ...state, page: PageType.ERROR };
        }
        default: {
          return state;
        }
      }
    }
    default: {
      return state;
    }
  }
};
